var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',_vm._l((_vm.wordpressData),function(page,index){return _c('b-col',{key:index},[(page && page.content)?_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(page.content.rendered)}})]):_vm._e()])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }